import { registerTrackerProvider } from '../index';
import { ga4Provider } from './ga4';
import { metaPixelProvider } from './meta-pixel';
import { gtmProvider } from './gtm';

let initialized = false;

export function initTrackingProviders(): void {
  if (initialized) return;
  initialized = true;
  registerTrackerProvider(ga4Provider);
  registerTrackerProvider(metaPixelProvider);
  registerTrackerProvider(gtmProvider);
}

initTrackingProviders();
